import { createAction } from "redux-actions";

export const LOGS_ACTIONS = {
    ADD: 'logs add'
}

export const logsActions = {
    add: createAction(LOGS_ACTIONS.ADD, (log) => ({ log }))
}